module.exports = __webpack_public_path__ + "static/media/corona.54959a3d.png";